export default function Footer() {
  const handleWhatsAppClick = (phone: string) => {
    const message = encodeURIComponent('Hola, quiero cotizar productos de madera con Aserradero Santa Rosa.');
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  const handleLocationClick = () => {
    window.open('https://maps.app.goo.gl/1j2NKJAJEtBS99Mx5', '_blank');
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const products = ['Polines', 'Tablas', 'Vigas', 'Tablones', 'Costaneras', 'Madera Cepillada'];
  const services = ['Cortes a medida', 'Cepillado', 'Asesoría técnica', 'Despacho', 'Retiro en planta'];

  return (
    <footer className="bg-[#2C2416] text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/712eeffae6bd09692d30f095b0e3dfd2/fcd018db8c20410ecd57316f5b829fce.png" 
                alt="Aserradero Santa Rosa Logo" 
                className="h-12 w-12 object-contain"
              />
              <div className="text-2xl font-serif font-bold text-[#F5E6D3]">
                Aserradero Santa Rosa
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-6">
              Tradición y calidad desde 2003
            </p>
          </div>

          <div>
            <h4 className="text-[#F5E6D3] font-bold text-lg mb-4">Productos</h4>
            <ul className="space-y-2">
              {products.map((product, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('productos')}
                    className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer whitespace-nowrap"
                  >
                    {product}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#F5E6D3] font-bold text-lg mb-4">Servicios</h4>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('servicios')}
                    className="text-gray-400 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer whitespace-nowrap"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#F5E6D3] font-bold text-lg mb-4">Contacto Directo</h4>
            
            <div className="space-y-3 mb-4">
              <button
                onClick={() => handleWhatsAppClick('56981372039')}
                className="w-full border-2 border-white text-white py-2.5 rounded-full font-semibold hover:bg-white hover:text-[#2C2416] transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-whatsapp-fill mr-2"></i>
                +56 9 8137 2039
              </button>
              
              <button
                onClick={() => handleWhatsAppClick('56974838794')}
                className="w-full border-2 border-white text-white py-2.5 rounded-full font-semibold hover:bg-white hover:text-[#2C2416] transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-whatsapp-fill mr-2"></i>
                +56 9 7483 8794
              </button>
            </div>

            <div className="text-sm mb-4">
              <p className="font-semibold text-[#F5E6D3] mb-1">Horarios:</p>
              <p className="text-xs">Lun-Vie: 8:30-18:00</p>
              <p className="text-xs">Sáb: 8:30-13:00</p>
            </div>
            
            <button
              onClick={handleLocationClick}
              className="text-sm flex items-center gap-2 text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer"
            >
              <i className="ri-map-pin-fill text-[#D4AF37]"></i>
              <span>Ver ubicación en mapa</span>
            </button>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center">
          <p className="text-sm text-gray-500">
            © 2025 Aserradero Santa Rosa - Todos los derechos reservados |{' '}
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-[#D4AF37] transition-colors whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
